<template>
    <div
        v-bind="cardBinds"
        tabindex="0"
        aria-label="Card"
        @click="$emit('click')"
    >
        <slot />
    </div>
</template>

<script setup lang="ts">
import { computed, useAttrs } from 'vue';

const attrs = useAttrs();
defineOptions({
    customOptions: {
        name: 'AxCard',
    },
});
defineProps({
    click: {
        type: Function,
        default: () => {
        },
    },
});
defineEmits(['click']);

const cardBinds = computed(() => {
    const { class: className, ...rest } = attrs;
    const cardClass = 'ax-card duration-200 ease-in-out';
    return {
        ...rest,
        class: [cardClass, className],
    };
});
</script>
<style scoped>
.ax-card {
    cursor: pointer;
    outline: 1px solid var(--color-surface-300);
    background-color: var(--color-surface-0);
}

.ax-card:hover {
    background-color: var(--color-surface-100);
}

.ax-card:focus-visible {
    outline: var(--p-focus-ring-width) var(--p-focus-ring-style) var(--p-focus-ring-color);
}

/* .dark .ax-card {
    background-color: var(--color-surface-100);
} */
</style>
